<template>
  <div>
    <ForeignOrganization :v="v" />

    <Assignee
      :v="v.assignee"
      label="Сведения о представителе иностранного юридического лица"
    />
  </div>
</template>

<script>
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
  prefillEsiaForeignOrg,
} from '@/components/services/EgrnConfirm/Applicant/components/ForeignOrganization';
import Assignee, {
  getAssigneeValidation,
  assigneeModel,
  prefillEsiaAssignee,
} from '@/components/services/EgrnConfirm/Applicant/components/Assignee';
import deepmerge from 'deepmerge';
import cloneDeep from 'clone-deep';

export const mrpaEnableAssigneeForeignOrganizationModel = deepmerge(
  foreignOrganizationModel,
  {
    assignee: assigneeModel,
  }
);

export const getMrpaEnableAssigneeForeignOrganizationValidation = (
  foreignOrganization
) => ({
  ...foreignOrganizationValidation,
  assignee: getAssigneeValidation(foreignOrganization.assignee),
});

export const prefillEsiaMrpaEnableAssigneeForeignOrganization = async () => {
  const esiaOrg = await prefillEsiaForeignOrg();

  return cloneDeep({
    ...mrpaEnableAssigneeForeignOrganizationModel,
    ...esiaOrg,
    assignee: await prefillEsiaAssignee(),
  });
};

export default {
  name: 'MrpaEnableAssigneeForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    ForeignOrganization,
    Assignee,
  },
};
</script>
